import React, { Component } from 'react'
import styled from 'styled-components'
import { MdCheck } from 'react-icons/lib/md'
import CtaButtonSm from './CtaButtonSm'

const iconStyle = {
  height: '25px'
}

class MobilePricingTable extends Component {
  constructor() {
    super()
  }

  handleSelectTab() {
    let tabs = document.querySelector('.tab-buttons')
    let forDevButton = tabs.childNodes[0]
    let forEntButton = tabs.childNodes[1]
    let forDevTab = document.querySelector('#for-developers-grid')
    let forEntTab = document.querySelector('#for-enterprise-grid')

    if (forDevButton.classList.contains('active')) {
      forEntButton.classList.add('active')
      forEntTab.style.display = 'grid'
      forDevButton.classList.remove('active')
      forDevTab.style.display = 'none'
    } else {
      forEntButton.classList.remove('active')
      forEntTab.style.display = 'none'
      forDevButton.classList.add('active')
      forDevTab.style.display = 'grid'
    }
  }

  render() {
    return (
      <MobilePricingTableContainer>
        <div className={'tab-buttons'}>
          <button onClick={this.handleSelectTab} className="active">
            For Developers
          </button>
          <button onClick={this.handleSelectTab}> For Enterprise</button>
        </div>
        <PricingGridItem id="for-developers-grid">
          <div className="placeholder" />
          <div className="cell heading" id="description-one">
            Pre-Production
          </div>
          <div className="cell heading" id="description-two">
            Production
          </div>
          <div className="cell" id="pricing" />
          <div className="cell main" id="price-one">
            <div>
              <h3>Free</h3>
            </div>
          </div>
          <div className="cell main" id="price-two">
            <div>
              <h3>.01</h3>
            </div>
          </div>
          <div className="placeholder" />
          <div className="cell generic after-pricing">
            <div>
              <p>Up to 1000 transactions per month</p>
            </div>
          </div>
          <div className="cell generic after-pricing">
            <div>
              <p>per transaction</p>
            </div>
          </div>
          <div className="cell generic" id="users">
            Number of Users
          </div>
          <div className="cell generic" id="ten">
            10
          </div>
          <div className="cell generic" id="users-unlimited-one">
            Unlimited
          </div>
          <div className="cell generic" id="limits">
            Transaction Limits
          </div>
          <div className="cell generic" id="thousand">
            1000
          </div>
          <div className="cell generic" id="limits-unlimited-one">
            Unlimited
          </div>
          <div className="cell generic" id="web">
            Web
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="ios">
            iOS
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="android">
            Android
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="branding">
            Custom Branding
          </div>
          <div className="cell generic"> </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="payments">
            Payments
          </div>
          <div className="cell generic"> </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="notifications">
            Notifications
          </div>
          <div className="cell generic">Push, Email</div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="placeholder" />
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
        </PricingGridItem>
        <PricingGridItem id="for-enterprise-grid">
          <div className="placeholder" />
          <div className="cell heading" id="description-one">
            Turn-key Solutions
          </div>
          <div className="cell heading" id="description-two">
            Software Resellers
          </div>
          <div className="cell" id="pricing" />
          <div className="cell main" id="price-one">
            <div>
              <h3>Contact Us</h3>
            </div>
          </div>
          <div className="cell main" id="price-two">
            <div>
              <h3>Contact Us</h3>
            </div>
          </div>
          <div className="placeholder" />
          <div className="cell generic after-pricing">
            <div>
              <p> </p>
            </div>
          </div>
          <div className="cell generic after-pricing">
            <div>
              <p> </p>
            </div>
          </div>
          <div className="cell generic" id="users">
            Number of Users
          </div>
          <div className="cell generic" id="users-unlimited-four">
            Unlimited
          </div>
          <div className="cell generic" id="users-unlimited-three">
            Unlimited
          </div>
          <div className="cell generic" id="limits">
            Transaction Limits
          </div>
          <div className="cell generic" id="limits-unlimited-two">
            Unlimited
          </div>
          <div className="cell generic" id="limits-unlimited-three">
            Unlimited
          </div>
          <div className="cell generic" id="web">
            Web
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="ios">
            iOS
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="android">
            Android
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="branding">
            Custom Branding
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="payments">
            Payments
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic">
            <MdCheck style={iconStyle} />
          </div>
          <div className="cell generic" id="notifications">
            Notifications
          </div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="cell generic">SMS, Push, Email</div>
          <div className="placeholder" />
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
          <div className="cell generic bottom">
            <CtaButtonSm bgColor={'#43AB60'} textColor={'#fff'} to={'/contact'}>
              Get Started
            </CtaButtonSm>
          </div>
        </PricingGridItem>
      </MobilePricingTableContainer>
    )
  }
}

export default MobilePricingTable

const MobilePricingTableContainer = styled.div`
  display: none;

  @media screen and (max-width: 762px) {
    display: block;
  }

  #for-developers-grid {
    display: grid;
  }

  #for-enterprise-grid {
    display: none;
  }

  .tab-buttons {
    margin-bottom: 20px;
    button {
      background: white;
      border: 1px solid #4eb964;
      padding: 10px;
      margin: 10px auto;
      font-size: 1.8rem;
    }

    button:first-child {
      border-radius: 5px 0 0 5px;
    }

    button:last-child {
      border-radius: 0 5px 5px 0;
    }

    .active {
      background: #4eb964;
      color: white;
    }
  }
`

const PricingGridItem = styled.div`
  // Styles, Grid stuff below:
  .cell {
    font-size: 1.4rem;
    color: #253858;
  }

  .heading {
    font-size: 1.4rem;
    width: 95%;
    margin: 0 auto;
    background: #707070 !important;
    color: white;
    border-radius: 5px 5px 0 0;
  }

  .heading:nth-child(2) {
    background: #707070 !important;
  }

  .heading:nth-child(1) {
    background: white !important;
  }

  .main {
    & div {
      width: 100%;
      min-height: 115%;
      margin: 5px 5px 0 5px;
      background: #4eb964 !important;
      border-radius: 5px 5px 0 0;
    }

    & h3 {
      color: white;
      font-size: 2rem;
      padding-top: 10px;
      font-weight: 600;
      justify-self: center;
      align-self: center;
      margin-top: auto;
    }
  }
  #contact-one,
  #contact-two {
    position: relative;
    & > div > h3 {
      position: relative;
      top: 15px;
    }
  }

  #free,
  #cent {
    & > div > h3 {
      position: relative;
      top: 15px;
    }
  }

  .after-pricing {
    & div {
      width: 100%;
      height: 100%;
      margin: 0 5px 15px 5px;
      background: #4eb964 !important;
      border-radius: 0 0 5px 5px;
      & p {
        color: white;
        margin: 0 auto auto;
        font-size: 1.2rem;
        width: 60%;
      }
    }
  }
  /*********
  GRID STUFF:
  **********/
  position: relative;
  display: grid;
  grid-template-columns: 75px repeat(2, 1fr);
  grid-template-rows: 50px 50px 80px repeat(8, 40px) 100px;
  grid-auto-rows: 40px;
  grid-column-gap: 10px;
  grid-auto-flow: row;
  grid-template-areas:
    '. description-one description-two'
    'pricing price-one price-two';

  .cell {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  #description-one {
    grid-area: description-one;
  }
  #description-two {
    grid-area: description-two;
  }
  #pricing {
    grid-area: pricing;
  }
  #price-one {
    grid-area: price-one;
  }
  #price-two {
    grid-area: price-two;
  }
`



// WEBPACK FOOTER //
// ./src/components/UI/MobilePricingTable.jsx